import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import AACChromeAPI, { ChromeEvent } from '@amzn/aac-chrome-api';
import { UserInfo } from '@amzn/aac-chrome-internal-api';
import { FocusPageHeader } from '@amzn/storm-ui-page-header';
import { RootState } from 'src/app/store';
import { Flag } from 'src/app/slice';
import { selectUserInfoFromHeader } from 'src/features/header/store/slice';
import didElementLoad from 'src/commons/utils/didElementLoad';
import { Actions } from '../PageHeader/Actions/Actions';
import { selectRenderTagInPageName } from 'src/features/nav/store/slice';
import { useChromeConfigContext } from 'src/providers/ChromeConfigContextProvider';
import { formatFlagType } from 'src/commons/components/LaunchFlag/LaunchFlag.utils';
import { LaunchFlag } from 'src/commons/components/LaunchFlag/LaunchFlag';

export const FocusHeader: React.VFC<{
  pageTitleTag?: Flag | null;
  userInfo: UserInfo;
}> = ({ pageTitleTag, userInfo }) => {
  useEffect(() => {
    didElementLoad('focusNav');
  }, []);
  const chromeConfig = useChromeConfigContext();
  const pageName = chromeConfig.pageHeader?.pageName;
  const renderTitle = chromeConfig.pageHeader?.getRenderTitle?.();
  const objectInfo = chromeConfig.pageHeader?.objectInfo;
  const actions = objectInfo?.actions?.list;
  const errorMessage = objectInfo?.actionErrorMessage;

  const handleCloseButtonClick = (event) => {
    if (typeof document !== 'undefined') {
      const eventTarget = AACChromeAPI.getCommonEventTarget();
      const chromeEvent = new ChromeEvent('ExitFocusView');
      chromeEvent.detail = {
        originEvent: event,
      };
      eventTarget.dispatchEvent(chromeEvent);
    }
  };

  return (
    <FocusPageHeader
      id="focusNav"
      applicationName={chromeConfig.appName}
      onClose={handleCloseButtonClick}
      title={renderTitle ?? pageName}
      renderActions={() => <Actions actions={actions} />}
      actionsErrorMessage={errorMessage}
      renderPageTitleIcon={() => (
        <>
          {pageTitleTag &&
            (() => {
              const flagType = formatFlagType(pageTitleTag.type);

              return (
                <LaunchFlag
                  flag={{
                    type:
                      flagType !== 'beta_ai_with_icon' ? flagType : undefined,
                    label: pageTitleTag.label,
                    description: pageTitleTag.description ?? pageTitleTag.label,
                  }}
                />
              );
            })()}
        </>
      )}
      locale={userInfo.languageInfo.currentLocale}
    />
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    pageTitleTag: selectRenderTagInPageName(state),
    userInfo: selectUserInfoFromHeader(state),
  };
};
export const ConnectedFocusHeader = connect(mapStateToProps)(FocusHeader);
